// src/components/Header.tsx
import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-gray-800 py-4">
      <div className="container mx-auto text-center">
        <h1 className="text-white text-4xl font-bold">
            Erwan Astro
        </h1>
      </div>
    </header>
  );
};

export default Header;